(function () {
    'use strict';

    angular
        .module('webinar')
        .controller('WebinarBlockDateUpdateController', WebinarBlockDateUpdateController);

    WebinarBlockDateUpdateController.$inject = ['$uibModalInstance','WebinarService', 'locations','event','calendar'];

    function WebinarBlockDateUpdateController($uibModalInstance, WebinarService, locations, event, calendar) {
        console.log(event);
        var vm = this;
        vm.locations = locations;
        vm.reason = event.title;
        vm.checkedLocations = {};
        vm.event = event;
        vm.storeBlockDate = storeBlockDate;
        vm.cancel = cancel;
        //vm.date = event.date;
        vm.convertToUTC = convertToUTC;
        vm.date = formatDate(event.date);
        vm.deleteDate = deleteDate;

        function formatDate(date)
        {
            date = new Date(date);
            return date.getDate() + '/' + date.getMonth() + '/' + date.getFullYear();
        }

        function convertToUTC(date)
        {
            var from = date.split("/");
            return new Date(Date.UTC(from[2], from[1], from[0]));
        }

        function storeBlockDate() {
            vm.query = {};
            vm.query['id'] = vm.event.id;
            vm.query['reason'] = vm.event.title;
            vm.query['locations'] = vm.checkedLocations;
            vm.query['date'] = vm.date;
            WebinarService.updateBlockDate(vm.query).then(function(response){
                $uibModalInstance.close();
                alertify.notify('Block date successfully saved', 'success', 3);
                calendar.events = [];
                WebinarService.getBlockedDates().then(function(response){
                    angular.forEach(response.data,function(value){
                        addEvent(value);
                    });
                });
            });
        }

        function cancel () {
            $uibModalInstance.close();
        }

        function deleteDate()
        {
            console.log(vm.event);
            alertify
                .confirm('This action is not reversible!')
                .set('labels', {
                    ok: 'Yes',
                    cancel: 'No'
                })
                .set('title', 'Do you really want to DELETE this Webinar block date?')
                .set('onok', function () {
                    vm.query = {};
                    vm.query['id'] = vm.event.id;
                    WebinarService.deleteBlockDate(vm.query).then(function() {
                        $uibModalInstance.close();
                        alertify.notify('Block date successfully deleted!', 'success', 3);
                        calendar.events = [];
                        WebinarService.getBlockedDates().then(function(response){
                            angular.forEach(response.data,function(value){
                                addEvent(value);
                            });
                        });
                    });
                })
                .show();
        }

        function addEvent(data) {
            vm.date = new Date(data.start.replace(/-/g,"/"));
            calendar.events.splice(data.id,0,{
                id : data.id,
                title: data.reason,
                start: vm.date,
                date : data.start,
                allDay: true,
                className: ['openSesame']
            });
        }

        function activate() {

            angular.forEach(vm.event.locations, function(value) {
                vm.checkedLocations[value.webinar_location_id] = true;
            });
        }

        activate();
    }

})();